const API_BASE_URL = process.env.REACT_APP_ANYFIT_API_URL;

// 다른 모듈에서 사용할 수 있도록 내보냄
export { API_BASE_URL };
